import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareListCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-list-custom-embed',
	path: '/jira/software/projects/:projectKey/list/:navigationItemId/embed',
};
